<template>
    <div>
        <!-- 上传1英寸头像 -->
        <a-upload list-type="picture-card" accept=".jpeg,.png,.jpg" :show-upload-list="false"
            :before-upload="beforeUpload" @change="
                (info) => {
                    handleImageChange(info)
                }
            ">
            <img class="one_inch_picture" v-if="state.one_inch_picture"
                :src="$store.state.user.image_domain + state.one_inch_picture" alt="avatar" />
            <div v-else>
                <PlusOutlined />
                <div class="ant-upload-text">上传用户自拍照</div>
            </div>
        </a-upload>
        <!-- 裁剪头像 -->
        <image-cropper @cancel="
            () => {
                state.showImageCropper = false
            }
        " :windowsSize="[130, 180]" :isId="false" :imageUrl="state.imageUrl" :imageName="state.imageName"
            @change="cropperImageChange" :upload_path="props.upload_path" :minKbSize="50"
            v-if="state.showImageCropper"></image-cropper>
    </div>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import ImageCropper from '@/components/ImageCropper/index.vue'
import { useStore } from 'vuex'
const $store = useStore()
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: String,
        default: () => ''
    },
    upload_path: {
        type: String,
        default: () => ''
    }
})
interface IState {
    one_inch_picture: String
    showImageCropper: boolean
    imageUrl: string
    imageName: String
}
const state = reactive<IState>({
    one_inch_picture: '',
    showImageCropper: false,
    imageUrl: '',
    imageName: ''
})
onMounted(() => {
    state.one_inch_picture = props.value
})
//改变值
const changeValue = (value: any) => {
    emit('update:value', state.one_inch_picture)
    emit('change', state.one_inch_picture)
}
watch(
    () => props.value,
    (val) => {
        if (val) {
            state.one_inch_picture = val
        }
    },
    {
        deep: true,
        immediate: true
    }
)
// 手动上传验证
const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        message.error('请上传正确图片！')
    }
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
        message.error('图片必须小于10MB!')
    }
    return false
}
// 裁剪头像
const handleImageChange = (info) => {
    const reader: any = new FileReader()
    const isGt50K = info.file.size / 1024 < 50
    if (isGt50K) {
        message.error('图片必须大于50KB!')
        return
    }
    if (!props.upload_path) {
        message.error('请先设置上传路径!')
        return
    }
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showImageCropper = true
    }
}
// 裁剪成功
const cropperImageChange = (res) => {
    state.one_inch_picture = res.url
    state.showImageCropper = false
    changeValue(state.one_inch_picture)
}
</script>
<style lang="less" scoped>
.one_inch_picture {
    width: 100px;
    height: 100px;
}
</style>
